import React, { useEffect, useMemo, useState } from "react";
import LinkedinSelectedReactionIcon from "./LinkedinSelectedReactionIcon";

const LinkedinReactionsSummary = ({ comments, totalCommentsCount, reactions }) => {
  const [reactionsIcons, setReactionsIcons] = useState();

  useEffect(
    () => {
      const uniqueReactions = Object.entries(reactions)
        .filter(([_key, value]) => typeof value === "object") // Exclude the "total" key
        .sort((a, b) => b[1].count - a[1].count) // Sort by count in descending order
        .map(([_key, value]) => value); // Extract the objects
      setReactionsIcons(uniqueReactions);
    },
    [reactions]
  );

  const getTotalCommentsCount = () => comments.reduce(
    ((partialSum, comment) => partialSum + 1
      + (comment?.commentsSummary?.aggregatedTotalComments || 0)), 0);

  const commentsCount = useMemo(getTotalCommentsCount, [comments]);

  return (
    <div className="Interactions-Container__Reactions">
      {reactionsIcons?.map(reaction => (
        <LinkedinSelectedReactionIcon
          key={reaction.reactionType}
          reaction={reaction}
        />
      ))}
      {reactions?.total > 0 && <span className="Reactions__Count">{reactions.total}</span>}
      {commentsCount && <span className="Comments__Count">{`${totalCommentsCount} comment${commentsCount === 1 ? "" : "s"}`}</span>}
    </div>
  );
};

export default LinkedinReactionsSummary;
